import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import SideMenuItem from './SideMenuItem';
import { validatePrivilege } from '../../helpers/adminPrivileges';
import { SideMenuCaptionLeftIcon, SideMenuCaptionRightIcon } from '../Common/Assets/SVGIcon/SiteAdminIcon';
import s from './SideMenuSection.css';

function SideMenuSection({ menuData, label, location, privileges, isSuperAdmin, handleMobileMenu }) {
    const showLabel = menuData?.some(item =>
        (item?.isValidatePrivilege && validatePrivilege(item?.privilegeId, privileges || [])) ||
        (item?.isSuperAdmin && isSuperAdmin) ||
        (!item?.isValidatePrivilege)
    );

    const filteredMenuData = menuData?.filter(item =>
        (item?.isValidatePrivilege && validatePrivilege(item?.privilegeId, privileges)) ||
        (item?.isSuperAdmin && isSuperAdmin) ||
        (!item?.isValidatePrivilege)
    );

    return (
        <div>
            {showLabel && label &&
                <div className={s.sideMenuGroupCaption}>
                    <span className={s.sideMenuGroupCaptionTextIcon}>
                        <SideMenuCaptionLeftIcon />
                    </span>
                    <span className={s.sideMenuGroupCaptionText}>{label}</span>
                    <span className={s.sideMenuGroupCaptionTextIcon}>
                        <SideMenuCaptionRightIcon />
                    </span>
                </div>}
            {filteredMenuData?.map((item, index) => {
                let isMenuActive = false;

                if (item?.activePaths?.length > 0 && location) {
                    isMenuActive = item.activePaths.some(path => location?.startsWith(path) && path !== '/siteadmin');
                }

                return (
                    <div key={index}>
                        <SideMenuItem
                            data={item}
                            keyValue={index}
                            location={location}
                            isMenuActive={isMenuActive}
                            handleMobileMenu={handleMobileMenu}
                        />
                    </div>
                );
            })}
        </div>
    );
}

export default withStyles(s)(SideMenuSection);
